import React, { useEffect } from "react";
import { Drawer } from "@mui/material";
import House from "../../Assets/images/rentrental.png";
import StarIcon from "@mui/icons-material/Star";
import FmdGoodOutlinedIcon from "@mui/icons-material/FmdGoodOutlined";
import CancelIcon from "@mui/icons-material/Cancel";
import Button from "../SelectValue/Button";
import PaymentMethod from "./PaymentMethod";

const drawerWidth = 650;
function RentalSidebar({ open, handleClose, rental }) {
  const [openPaymentMethod, setOpenPaymentMethod] = React.useState(false);
  const [currentImageIndex, setCurrentImageIndex] = React.useState(0);

  const imagesArray = rental?.apartmentClassImagesDTOS || rental?.apartmentImages;
  const images =
    imagesArray?.length > 0
      ? imagesArray.map((img) => img?.imageUrl || House)
      : [House, House, House, House];

  const handleOpenPaymentMethod = () => {
    setOpenPaymentMethod(true);
  };

  const handleClosePaymentMethod = () => {
    setOpenPaymentMethod(false);
  };

  const isRentExceeded = React.useMemo(() => {
    if (!rental?.rentExpires) return false;
    let expiryDate;
    if (Array.isArray(rental.rentExpires)) {
      expiryDate = new Date(rental.rentExpires[0], rental.rentExpires[1] - 1, rental.rentExpires[2]);
    } else {
      expiryDate = new Date(rental.rentExpires);
    }
    const currentDate = new Date();
    currentDate.setHours(0, 0, 0, 0);
    expiryDate.setHours(0, 0, 0, 0);
    return currentDate >= expiryDate;
  }, [rental?.rentExpires]);

  return (
    <div>
      <PaymentMethod
        open={openPaymentMethod}
        handleClose={handleClosePaymentMethod}
        handleCloseSidebar={handleClose}
        data={rental}
        isRenewal={true}
      />
      <Drawer
        anchor="right"
        variant="temporary"
        open={open}
        onClose={handleClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "block" },
          "& .MuiDrawer-paper": {
            boxSizing: "border-box",
            width: { xs: "100%", sm: drawerWidth },
            backgroundColor: "white",
          },
        }}
      >
        <div>
          <div className=" p-4 border-b border-b-gray-200 flex justify-between">
            <p className=" text-back-color2 capitalize text-[18px] pt-3 font-bold">
              Apartment details
            </p>
            <div className="pt-2">
              <CancelIcon
                onClick={handleClose}
                className=" text-gray-800 cursor-pointer"
                fontSize="large"
              />
            </div>
          </div>
          <div className=" p-3">
            <div className="relative group mb-4">
              <img
                src={images[currentImageIndex]}
                alt="house"
                className="w-full h-[300px] object-cover rounded-[20px]"
              />
              <div className="flex justify-center mt-3 gap-1">
                {images.map((_, index) => (
                  <div
                    key={index}
                    onClick={() => setCurrentImageIndex(index)}
                    className={`h-1.5 rounded-full cursor-pointer transition-all duration-300 ${index === currentImageIndex ? "w-6 bg-gray-800" : "w-4 bg-gray-400"}`}
                  ></div>
                ))}
              </div>
            </div>
            <div className=" mt-6">
              <div className="flex justify-between items-start mb-2">
                <div className="w-2/3 flex flex-col gap-3">
                  <p className="text-[24px] font-[700] text-back-color2 leading-tight">
                    {rental?.apartmentName || ""}
                  </p>
                  <p className="text-[16px] font-[700] text-back-color2 leading-tight">
                    NGN {rental?.price || ""}/year
                  </p>
                </div>

              </div>

              <div className=" mt-1 mb-6 flex gap-4 items-center">
                <p className="text-[14px] text-back-color2 flex items-center font-medium">
                  {/* <StarIcon
                    sx={{ fontSize: 18 }}
                    className="text-[#e4c925] mr-1"
                  />{" "}
                  4.0 (26){" "}
                  <FmdGoodOutlinedIcon
                    sx={{ fontSize: 18 }}
                    className="ml-3 mr-1"
                  />{" "} */}
                  {rental?.street || ""} • {rental?.location || ""}
                </p>
              </div>

              <div className=" my-3 bg-white border shadow-md rounded-xl p-4 ">
                <div className=" mb-3 flex justify-between">
                  <div>
                    <p className=" text-[#696C72] font-[500] text-[14px]">
                      Amount Paid
                    </p>
                  </div>
                  <div>
                    <p className=" text-primary-color font-[700] text-[14px]">
                      NGN {rental?.price || ""}
                    </p>
                  </div>
                </div>
                <div className=" mb-3 flex justify-between">
                  <div>
                    <p className=" text-[#696C72] font-[500] text-[14px]">
                      Rent Tenure
                    </p>
                  </div>
                  <div>
                    <p className=" text-back-color2 font-[600] text-[14px]">
                      {rental?.rentTenure}
                    </p>
                  </div>
                </div>
                <div className=" mb-1 flex justify-between">
                  <div>
                    <p className=" text-[#696C72] font-[500] text-[14px]">
                      Rent expires
                    </p>
                  </div>
                  <div>
                    <p className=" text-back-color2 font-[700] text-[14px]">
                      {rental?.rentExpires && Array.isArray(rental.rentExpires)
                        ? new Date(rental.rentExpires[0], rental.rentExpires[1] - 1, rental.rentExpires[2]).toLocaleDateString("en-US", { year: "numeric", month: "short", day: "numeric" })
                        : rental?.rentExpires || "N/A"}
                    </p>
                  </div>
                </div>
              </div>

              {/* rent payment transaction history */}
              {/* <div className=" mt-6">
                <p className=" text-back-color2 font-[700] text-[16px] mb-3">
                  Rent Payment History
                </p>
                <div className=" mb-3 flex justify-between border border-gray-100 shadow-sm rounded-xl p-4 bg-white">
                  <div>
                    <p className=" text-back-color2 font-[600] text-[14px]">
                      3 years rent payment
                    </p>
                    <p className=" text-[#C2C9D1] font-[400] text-[12px] mt-1">
                      Success
                    </p>
                  </div>
                  <div className="text-right">
                    <p className=" text-primary-color font-[600] text-[14px]">
                      +NGN 750,000
                    </p>
                    <p className=" text-[#C2C9D1] font-[400] text-[12px] mt-1">
                      Sep 4, 2023
                    </p>
                  </div>
                </div>
              </div> */}
              <div className=" grid mt-10">
                <Button
                  name="Renew Rent"
                  onClick={handleOpenPaymentMethod}
                  className="bg-[#00A859] text-white w-full py-3 rounded-lg font-bold"
                  disabled={!isRentExceeded}
                />
              </div>
            </div>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default RentalSidebar;
